import React, { useState, useContext } from 'react';
import { Authentication } from '../../App'
import axios from "axios";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useDropzone } from 'react-dropzone';
import Button from '@mui/material/Button';
import Dropzone from 'react-dropzone';
import Modal from '@mui/material/Modal';


const style = {
  position: 'absolute',
  top: '30%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '15%',
  height: '5%',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 6,
};



function Introduction() {
  const authentication = useContext(Authentication);

  const [data_id, setData_id] = useState();
  const [loading, setLoading] = useState(false);
  const [checks, setChecks] = useState([]);
  const [checklock, setChecklock] = useState(false);
  const [user, setUser] = useState("");
  const [syumi, setSyumi] = useState("");
  const [tokugi, setTokugi] = useState("");
  const [comment, setComment] = useState("");
  const [blob, setBlob] = useState("");
  const [iconblob, setIconblob] = useState("");
  const [file, setfile] = useState();
  const [file_change_flag, setFile_change_flag] = useState(false);
  const [button_disp, setButton_disp] = useState(true);


  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const files = acceptedFiles.map(file => {
    var blobUrl = window.URL.createObjectURL(file);
    return <img src={blobUrl} alt={'img_url'} />
  });

  // 画像アップロード  
  const onDrop = (filess) => {
    if (filess[1]) {
      alert("アップロードするファイルは１ファイルにしてください")
      return false;
    }
    if (filess[0].type.match(/image/)) {
      var blobUrl = window.URL.createObjectURL(filess[0]);
      setBlob(<img src={blobUrl} alt={'img_url'} />);
      setIconblob(<img style={{ width: 30, height: 30 }} src={blobUrl} alt={'img_url'} />);
      setfile(filess);
      // 画像をアップロードした（変更した）ことがわかるフラグ
      setFile_change_flag(true);
    } else {
      alert("画像ファイルを選択してください")
    }
  }

  const check = (e) => {
    // チェックを付けた時
    if (e.target.checked) {
      var data = checks;
      data.push(e.target.value);
      setChecks(data);
    } else {
      var index = checks.indexOf(e.target.value);
      var data = checks;
      data.splice(index, 1);
      setChecks(data);
    }

    // ２つ選んでたら選択できなくする
    if (checks.length > 1) {
      setChecklock(true);
    } else {
      setChecklock(false);
    }
  }



  // 画像をアップロードする
  const img_upload = (id) => {
    // let url2 = `http://localhost:5000/v1/user/introductions/upfile/` + id;
    let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/user/introductions/upfile/` + id;

    const token = authentication.getAccessToken();
    var formData = new FormData();
    formData.append("files", file[0]);
    fetch(url2, {
      method: 'post',
      body: formData,
      headers: { 'Authorization': 'Bearer ' + token },
    })
      .then(() => {
        // alert("保存しました");
        setTimeout(() => {
          setButton_disp(true);
          handleOpen();
        }, 1000)
      });
  }


  // フォームの内容を保存する
  const hozon = (flag) => {
    setButton_disp(false);
    if (!checks[0]) {
      alert("推しポイントが選ばれていません")
      return false;
    }
    if (syumi == "") {
      alert("趣味が記入されていません")
      return false;
    }
    if (tokugi == "") {
      alert("特技が記入されていません")
      return false;
    }
    if (comment == "") {
      alert("コメントが記入されていません")
      return false;
    }

    // 保存時、data_idがあればupdate,なければinsert
    if (data_id) {
      // let url = `http://localhost:5000/v1/user/introductions/update`;
      let url = process.env.REACT_APP_API_BASE_URL + `/v1/user/introductions/update`;
      axios.post(url, {
        id: data_id,
        data: {
          user_id: user.id,
          pushing_point: checks,
          hobby: syumi,
          special_skill: tokugi,
          comment: comment
        }
      }).then((abc) => {
        // 画像がアップされている場合
        if (file_change_flag) {
          img_upload(abc.data.id);
        } else {
          // alert("保存しました");
          setTimeout(() => {
            setButton_disp(true);
            handleOpen();
          }, 1000)
        }
      });
    } else {
      // let url = `http://localhost:5000/v1/user/introductions/insert`;
      let url = process.env.REACT_APP_API_BASE_URL + `/v1/user/introductions/insert`;
      axios.post(url, {
        user_id: user.id,
        pushing_point: checks[1] ? checks[0] + "," + checks[1] : checks[0],
        hobby: syumi,
        special_skill: tokugi,
        comment: comment,
        created_user: user.id,
        created_at: new Date()
      }).then((abc) => {
        // 画像がアップされている場合
        if (file_change_flag) {
          img_upload(abc.data.id);
          setData_id(abc.data.id);
        } else {
          // alert("保存しました");
          setTimeout(() => {
            setData_id(abc.data.id);
            setButton_disp(true);
            handleOpen();
          }, 1000)
        }
      });
      // }
    }
  }


  React.useEffect(() => {
    // let url = `http://localhost:5000/v1/users/detail`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/users/detail`;
    axios.get(url, { headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
      setUser(response.data)

      // すでに入力済みのデータを取得する
      // let url2 = `http://localhost:5000/v1/user/introductions/detail/` + response.data.id;
      let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/user/introductions/detail/` + response.data.id;
      axios.get(url2).then((abc) => {
        if (abc.data.id) {
          setLoading(true);
          if (abc.data.image_url) {
            setBlob(<img src={abc.data.image_url} alt={'img_url'} />);
            setIconblob(<img style={{ width: 30, height: 30 }} src={abc.data.image_url} alt={'img_url'} />);
          }
          setData_id(abc.data.id);
          setSyumi(abc.data.hobby);
          setTokugi(abc.data.special_skill);
          setComment(abc.data.comment);
          var data = abc.data.pushing_point.split(',');
          setChecks(data);
          if (data.length > 1) {
            setChecklock(true);
          } else {
            setChecklock(false);
          }
          setTimeout(() => {
            setLoading(false);
          }, 1)
        }
      });
    });
  }, []);

  return (
    <Box className="App" id="content">
      <Grid container columns={12} gap={2} direction="row" justifyContent="center" alignItems="stretch" className="container">
        <Grid item xs={12} className="tab-list">
          <TableContainer component={Paper} elevation={0} sx={{ mb: 3 }}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: 20, fontWeight: 'bold' }}>自己紹介</TableCell>
                  <TableCell align="right" style={{ fontWeight: "bold" }}>{iconblob}{user.user_name_all}</TableCell>
                </TableRow>
              </TableHead>
              {loading == false ?
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">推しポイント（2つまで）</FormLabel>
                        <FormGroup aria-label="position" row>
                          <FormControlLabel
                            value="1"
                            control={checklock ?
                              checks.indexOf("1") !== -1 ? <Checkbox defaultChecked /> : <Checkbox disabled />
                              : checks.indexOf("1") !== -1 ? <Checkbox defaultChecked /> : <Checkbox />}
                            label="宅建資格"
                            labelPlacement="end"
                            sx={{ mr: 3 }}
                            onChange={check}
                          />
                          <FormControlLabel
                            value="2"
                            control={checklock ?
                              checks.indexOf("2") !== -1 ? <Checkbox defaultChecked /> : <Checkbox disabled />
                              : checks.indexOf("2") !== -1 ? <Checkbox defaultChecked /> : <Checkbox />}
                            label="地元密着"
                            labelPlacement="end"
                            sx={{ mr: 3 }}
                            onChange={check}
                          />
                          <FormControlLabel
                            value="3"
                            control={checklock ?
                              checks.indexOf("3") !== -1 ? <Checkbox defaultChecked /> : <Checkbox disabled />
                              : checks.indexOf("3") !== -1 ? <Checkbox defaultChecked /> : <Checkbox />}
                            label="単身応援"
                            labelPlacement="end"
                            sx={{ mr: 3 }}
                            onChange={check}
                          />
                          <FormControlLabel
                            value="4"
                            control={checklock ?
                              checks.indexOf("4") !== -1 ? <Checkbox defaultChecked /> : <Checkbox disabled />
                              : checks.indexOf("4") !== -1 ? <Checkbox defaultChecked /> : <Checkbox />}
                            label="経験豊富"
                            labelPlacement="end"
                            sx={{ mr: 3 }}
                            onChange={check}
                          />
                          <FormControlLabel
                            value="5"
                            control={checklock ?
                              checks.indexOf("5") !== -1 ? <Checkbox defaultChecked /> : <Checkbox disabled />
                              : checks.indexOf("5") !== -1 ? <Checkbox defaultChecked /> : <Checkbox />}
                            label="女性目線"
                            labelPlacement="end"
                            sx={{ mr: 3 }}
                            onChange={check}
                          />
                          <FormControlLabel
                            value="6"
                            control={checklock ?
                              checks.indexOf("6") !== -1 ? <Checkbox defaultChecked /> : <Checkbox disabled />
                              : checks.indexOf("6") !== -1 ? <Checkbox defaultChecked /> : <Checkbox />}
                            label="家族目線"
                            labelPlacement="end"
                            onChange={check}
                          />
                        </FormGroup>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <TextField
                        label="趣味"
                        name="strong_points"
                        fullWidth
                        value={syumi}
                        onChange={(e) => { setSyumi(e.target.value) }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <TextField
                        label="特技"
                        name="strong_points"
                        fullWidth
                        value={tokugi}
                        onChange={(e) => { setTokugi(e.target.value) }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <TextField
                        label="コメント"
                        multiline
                        rows={4}
                        fullWidth
                        value={comment}
                        onChange={(e) => { setComment(e.target.value) }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>
                      {blob}
                      <Dropzone
                        onDrop={onDrop}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div {...getRootProps({ className: 'dropzone' })} style={{ background: "#f5f5f5", height: 60, width: 500, border: "solid" }}>
                            <input {...getInputProps()} />
                            <div>
                              <p>クリックまたはドラッグでファイルをアップロード</p>
                              <ul style={{ padding: 0, marginTop: 3 }}  >

                              </ul>
                            </div>
                          </div>
                        )}
                      </Dropzone>
                    </TableCell>
                  </TableRow>
                </TableBody>




                // ここから下は単なる空白
                :
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">推しポイント（2つまで）</FormLabel>
                        <div style={{ height: 40 }}></div>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <TextField
                        label="趣味"
                        name="strong_points"
                        fullWidth
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <TextField
                        label="特技"
                        name="strong_points"
                        fullWidth
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>
                      {/* <TextField
                    label="コメント"
                    name="strong_points"
                    fullWidth
                  /> */}
                      <TextField
                        label="コメント"
                        multiline
                        rows={4}
                        fullWidth
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <div>
                        <div {...getRootProps({ className: 'dropzone' })}>
                          <input {...getInputProps()} />
                          <p>画像アップ　クリックまたはドラッグ</p>
                        </div>
                        <ul>
                          {files}
                        </ul>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>


              }
            </Table>
          </TableContainer>
          {button_disp ?
            <Button onClick={hozon} variant="contained" color='success'>登録</Button> :
            <Button disabled variant="contained" color='success'>登録</Button>}
        </Grid>
      </Grid>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box sx={style}>
          <Grid>保存しました</Grid>

          <Grid style={{ textAlign: "right", marginTop: 10 }} >
            <Button onClick={() => setOpen(false)} size="small" variant="contained" color='error'>閉じる</Button>
          </Grid>
        </Box>
      </Modal>


      <style jsx="true">{
        `
        @media screen and (max-width: 768px){
          .css-quj9j6-MuiTable-root {
            min-width: 0;
          }
        }
        body {
          background: #E9F2F8;
          color: #292f33;
          font-family: 'Lucida Grande','Hiragino Kaku Gothic ProN','ヒラギノ角ゴ ProN W3',Meiryo,メイリオ, sans-serif;
        }
        .GADbox{
          margin: 0 auto;
        }
        .top_box{
          text-align: left;
          padding-bottom:20px;
        }
        .tab-list {
          padding:20px !important;
          background-color: #fff;
          border-radius: 5px;
          margin:0;
        }
        .NewsTitle{
          text-align: left;
          padding-right: 20px;
          font-size:15px;
          font-weight: bold;
        }
        .Table{
          font-size:15px;
        }
        
        .container {
          padding: 0px 20px;
          max-width: 1260px;
          margin-right: auto;
          margin-left: auto;
          margin-bottom: 20px;
        }
        
        .news_table{
          background-color:#fff;
          paddnig: 15px !important;
        }

        .news_container{
          background-color:#fff;
          paddnig: 15px !important;
        }

        `
      }
      </style>
    </Box>
  );
};

export default Introduction;
